import { StyleSheet, View } from 'react-native';
import { Text, theme, styles as baseStyles } from '@socrait/react';

import { firstRunPng1 } from './assets';

export const WelcomeSlide = () => {
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>Welcome to Socrait!</Text>
        <Text style={styles.text}>
          Socrait listens and converts your voice into{' '}
          <Text style={[baseStyles.boldText, styles.text]}>actionable data</Text>.{'\n'}
          <Text style={[styles.text, baseStyles.boldText, styles.purpleText]}>All without recording.</Text>
        </Text>
      </View>
      <img src={firstRunPng1} style={styles.image} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    gap: theme.spacing.xxlarge,
    paddingHorizontal: theme.spacing.xxlarge,
    flexWrap: 'wrap',
  },
  textContainer: {
    flexDirection: 'column',
    flexShrink: 1,
    justifyContent: 'center',
    gap: theme.spacing.xxlarge,
    maxWidth: 400,
  },
  title: {
    fontSize: theme.fontSizes.xlarge,
  },
  text: {
    fontSize: theme.fontSizes.xmedium,
    lineHeight: 33.6, //TODO: add this to socrait-react
    justifyContent: 'center',
  },
  purpleText: {
    color: theme.colors.primaryPurple,
  },
  image: {
    height: 250,
    marginTop: 'auto',
    marginBottom: 'auto',
  },
});
